import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerListModel } from "./customer.model";
import { Customer } from "Features/services/customer.api";
import { AxiosError } from "axios";

interface CustomerState {
  customersList: CustomerListModel[];
  customerListFetching: boolean;
  customerListFetchError: string;
  access_token: string;
  customersCount: number;
}

const initialState: CustomerState = {
  customersList: [],
  customerListFetching: false,
  customerListFetchError: "",
  access_token: "",
  customersCount: 0,
};

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listCustomer.pending, (state) => {
      state.customerListFetching = true;
      state.customerListFetchError = "";
    });
    builder.addCase(
      listCustomer.fulfilled,
      (state, action: PayloadAction<any>) => {
        if (action.payload.status === "success") {
          state.customersList = action.payload?.data;
          state.customerListFetching = false;
          state.customerListFetchError = "";
        } else {
          state.customerListFetchError = action.payload.error_message;
          state.customerListFetching = false;
        }
      }
    );
    builder.addCase(listCustomer.rejected, (state, action) => {
      state.customersList = [];
      state.customerListFetching = false;
      state.customerListFetchError = "";
    });

    // QB Access Token
    builder.addCase(
      getAccessToken.fulfilled,
      (state, action: PayloadAction<any>) => {
        if (action.payload.status === "success") {
          state.access_token = action.payload?.data;
        }
      }
    );
    builder.addCase(getAccessToken.rejected, (state, action) => {
      state.access_token = "";
    });

    // QB Customers Count
    builder.addCase(
      getAllCustomersCount.fulfilled,
      (state, action: PayloadAction<any>) => {
        if (action.payload.status === "success") {
          state.customersCount = action.payload?.data;
        }
      }
    );
    builder.addCase(getAllCustomersCount.rejected, (state, action) => {
      state.customersCount = 0;
    });
  },
});

export const getAccessToken = createAsyncThunk(
  "customer/getAccessToken",
  async () => {
    try {
      const { data } = await Customer.instance.getAccessToken();
      return data;
    } catch (error: AxiosError | any) {
      return {
        error_message: error?.response?.data?.message || "Something went wrong",
      };
    }
  }
);

export const listCustomer = createAsyncThunk(
  "customer/listCustomer",
  async (payload: {
    access_token: string;
    offset: number;
    tab: "all" | "new";
  }) => {
    try {
      const { data } = await Customer.instance.listCustomers(payload);
      return data;
    } catch (error: AxiosError | any) {
      return {
        error_message: error?.response?.data?.message || "Something went wrong",
      };
    }
  }
);

export const getAllCustomersCount = createAsyncThunk(
  "customer/getAllCustomersCount",
  async (access_token: string) => {
    try {
      const { data } = await Customer.instance.getAllCustomersCount(
        access_token
      );
      return data;
    } catch (error: AxiosError | any) {
      return {
        error_message: error?.response?.data?.message || "Something went wrong",
      };
    }
  }
);
export default customerSlice.reducer;
